import zh from '../lang/zh-cn'
import jp from '../lang/jp'
// import storage from "./storage.js";

const lang = {
  local: "zh",
  msg: {
    zh,
    jp
  },
  t(name, mod) {
    return mod ? lang.msg[lang.local][mod][name] : lang.msg[lang.local][name]
  },
  changeLang(lang) {
    switch (lang) {
      case "jp":
        window.location.href = window.location.href.replace("/zh/", "/");
        break;
      case "zh":
        window.location.href = window.location.href.replace(/(\/\/.*?)\/.*?#\//, '$1/zh/#/');
      default:
        break;
    }
  }
}

export default lang